/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */


// falling cigs

export function cigs(canvas) {
  const gl = canvas.getContext("webgl2", { alpha: true });
  if (!gl) return console.error("WebGL2 not supported");

  // canvas size
  function resize() {
    canvas.width = innerWidth * devicePixelRatio;
    canvas.height = innerHeight * devicePixelRatio;
    gl.viewport(0, 0, canvas.width, canvas.height);
  }
  resize();
  addEventListener("resize", resize);

  const width = document.documentElement.clientWidth;

  const COUNT = width * 0.5;
  const WORLD_WIDTH = width / 42;
  const WORLD_DEPTH = 16;
  const TOP_SPAWN = 60;
  const TOP_SPAWN_OFFSET = 18;
  const BOTTOM_KILL = -120;
  const BASE_FALL_SPEED = 4.3333;

  // cig geometry
  function makeCylinder(radius, height, segments, offsetY = 0, color = [1, 1, 1]) {
    const verts = [];
    const norms = [];
    const colors = [];

    const h = height / 2;

    // sides
    for (let i = 0; i < segments; i++) {
      const a0 = (i / segments) * Math.PI * 2;
      const a1 = ((i + 1) / segments) * Math.PI * 2;

      const x0 = Math.cos(a0) * radius;
      const z0 = Math.sin(a0) * radius;
      const x1 = Math.cos(a1) * radius;
      const z1 = Math.sin(a1) * radius;

      const topA = [x0, h + offsetY, z0];
      const topB = [x1, h + offsetY, z1];
      const botA = [x0, -h + offsetY, z0];
      const botB = [x1, -h + offsetY, z1];

      const tri = [...topA, ...botA, ...topB, ...topB, ...botA, ...botB];
      verts.push(...tri);

      const n0 = [x0, 0, z0];
      const n1 = [x1, 0, z1];
      const sideNorms = [...n0, ...n0, ...n1, ...n1, ...n0, ...n1];
      norms.push(...sideNorms);

      for (let k = 0; k < 6; k++) colors.push(...color);
    }

    // top disc
    for (let i = 0; i < segments; i++) {
      const a0 = (i / segments) * Math.PI * 2;
      const a1 = ((i + 1) / segments) * Math.PI * 2;

      const x0 = Math.cos(a0) * radius;
      const z0 = Math.sin(a0) * radius;
      const x1 = Math.cos(a1) * radius;
      const z1 = Math.sin(a1) * radius;

      const center = [0, h + offsetY, 0];
      const p0 = [x0, h + offsetY, z0];
      const p1 = [x1, h + offsetY, z1];

      verts.push(...center, ...p0, ...p1);
      for (let k = 0; k < 3; k++) norms.push(0, 1, 0);
      for (let k = 0; k < 3; k++) colors.push(...color);
    }

    // bottom disc
    for (let i = 0; i < segments; i++) {
      const a0 = (i / segments) * Math.PI * 2;
      const a1 = ((i + 1) / segments) * Math.PI * 2;

      const x0 = Math.cos(a0) * radius;
      const z0 = Math.sin(a0) * radius;
      const x1 = Math.cos(a1) * radius;
      const z1 = Math.sin(a1) * radius;

      const center = [0, -h + offsetY, 0];
      const p0 = [x0, -h + offsetY, z0];
      const p1 = [x1, -h + offsetY, z1];

      verts.push(...center, ...p1, ...p0);
      for (let k = 0; k < 3; k++) norms.push(0, -1, 0);
      for (let k = 0; k < 3; k++) colors.push(...color);
    }

    return { verts, norms, colors };
  }

  // radius, height
  const body = makeCylinder(0.1, 1, 16, 0, [0.96, 0.96, 0.96]);
  const filter = makeCylinder(0.1, 0.5, 16, 0.745, [0.93, 0.58, 0.12]);

  const vertices = new Float32Array([...body.verts, ...filter.verts]);
  const normals = new Float32Array([...body.norms, ...filter.norms]);
  const colors = new Float32Array([...body.colors, ...filter.colors]);
  const VERT_COUNT = vertices.length / 3;


  // buffer stuff
  function bufferData(target, data, usage = gl.STATIC_DRAW) {
    const buf = gl.createBuffer();
    gl.bindBuffer(target, buf);
    gl.bufferData(target, data, usage);
    return buf;
  }

  const vboPos = bufferData(gl.ARRAY_BUFFER, vertices);
  const vboNorm = bufferData(gl.ARRAY_BUFFER, normals);
  const vboCol = bufferData(gl.ARRAY_BUFFER, colors);

  // random cig movement
  const pos = new Float32Array(COUNT * 3);
  const vel = new Float32Array(COUNT * 3);
  const rot = new Float32Array(COUNT * 3);
  const rotSpeed = new Float32Array(COUNT * 3);
  const scaleY = new Float32Array(COUNT);

  function seed(i) {
    pos[3 * i + 0] = (Math.random() * 2 - 1) * WORLD_WIDTH * 0.5;
    pos[3 * i + 1] = TOP_SPAWN * Math.random() + TOP_SPAWN_OFFSET;
    pos[3 * i + 2] = (Math.random() * 2 - 1) * WORLD_DEPTH * 0.5;

    vel[3 * i + 0] = (Math.random() * 2 - 1) * 0.15;
    vel[3 * i + 1] = BASE_FALL_SPEED * (0.6 + Math.random() * 1.2);
    vel[3 * i + 2] = (Math.random() * 2 - 1) * 0.05;

    rot[3 * i + 0] = Math.random() * Math.PI * 2;
    rot[3 * i + 1] = Math.random() * Math.PI * 2;
    rot[3 * i + 2] = Math.random() * Math.PI * 2;

    rotSpeed[3 * i + 0] = (Math.random() * 2 - 1) * 1.2;
    rotSpeed[3 * i + 1] = (Math.random() * 2 - 1) * 1.2;
    rotSpeed[3 * i + 2] = (Math.random() * 2 - 1) * 1.2;

    scaleY[i] = 0.9 + Math.random() * 1.4;
  }
  for (let i = 0; i < COUNT; i++) seed(i);

  const instanceMatrices = new Float32Array(COUNT * 16);
  const vboInstance = bufferData(gl.ARRAY_BUFFER, instanceMatrices, gl.DYNAMIC_DRAW);

  // SHADERS
  const vs = `#version 300 es
  precision highp float;

  in vec3 aPosition;
  in vec3 aColor;
  in vec3 aNormal;
  in mat4 aInstanceMatrix;

  out vec3 vColor;
  out vec3 vNormal;

  uniform mat4 uProjection;
  uniform mat4 uView;

  void main() {
    vec4 worldPos = aInstanceMatrix * vec4(aPosition,1.0);
    vNormal = mat3(aInstanceMatrix) * aNormal;
    vColor = aColor;
    gl_Position = uProjection * uView * worldPos;
  }`;

  const fs = `#version 300 es
  precision highp float;

  in vec3 vColor;
  in vec3 vNormal;
  out vec4 outColor;

  void main() {
    vec3 N = normalize(vNormal);
    vec3 L = normalize(vec3(0.4, 0.8, 0.6));
    float diff = max(dot(N, L), 0.0) * 0.8 + 0.2;
    outColor = vec4(vColor * diff, 1.0);
  }`;

  function compile(type, src) {
    const sh = gl.createShader(type);
    gl.shaderSource(sh, src);
    gl.compileShader(sh);
    if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) throw gl.getShaderInfoLog(sh);
    return sh;
  }

  const prog = gl.createProgram();
  gl.attachShader(prog, compile(gl.VERTEX_SHADER, vs));
  gl.attachShader(prog, compile(gl.FRAGMENT_SHADER, fs));
  gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw gl.getProgramInfoLog(prog);

  gl.useProgram(prog);

  const locPos = gl.getAttribLocation(prog, "aPosition");
  const locCol = gl.getAttribLocation(prog, "aColor");
  const locNorm = gl.getAttribLocation(prog, "aNormal");
  const locMat = [
    gl.getAttribLocation(prog, "aInstanceMatrix"),
    gl.getAttribLocation(prog, "aInstanceMatrix") + 1,
    gl.getAttribLocation(prog, "aInstanceMatrix") + 2,
    gl.getAttribLocation(prog, "aInstanceMatrix") + 3,
  ];
  const uProjection = gl.getUniformLocation(prog, "uProjection");
  const uView = gl.getUniformLocation(prog, "uView");

  function enableVec3(buffer, attrib) {
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.enableVertexAttribArray(attrib);
    gl.vertexAttribPointer(attrib, 3, gl.FLOAT, false, 0, 0);
  }

  enableVec3(vboPos, locPos);
  enableVec3(vboCol, locCol);
  enableVec3(vboNorm, locNorm);

  gl.bindBuffer(gl.ARRAY_BUFFER, vboInstance);
  for (let i = 0; i < 4; i++) {
    gl.enableVertexAttribArray(locMat[i]);
    gl.vertexAttribPointer(locMat[i], 4, gl.FLOAT, false, 64, i * 16);
    gl.vertexAttribDivisor(locMat[i], 1);
  }

  // camera 
  // TODO: this looks wack as hell
  function makePerspective(fov, aspect, near, far) {
    const f = 1 / Math.tan(fov / 2);
    return new Float32Array([
      f / aspect, 0, 0, 0,
      0, f, 0, 0,
      0, 0, (far + near) / (near - far), -1,
      0, 0, (2 * far * near) / (near - far), 0
    ]);
  }
  const proj = makePerspective(Math.PI * 0.18, canvas.width / canvas.height, 0.1, 2000);
  gl.uniformMatrix4fv(uProjection, false, proj);

  const view = new Float32Array([
    1, 0, 0, 0,
    0, 1, 0, 0,
    0, 0, 1, 0,
    0, -4, -20, 1
  ]);
  gl.uniformMatrix4fv(uView, false, view);

  // react to scroll 
  let scrollPrev = scrollY;
  let scrollVel = 0;
  addEventListener("scroll", () => {
    const y = scrollY;
    scrollVel = y - scrollPrev;
    scrollPrev = y;
  });


// TODO: who the fuck is euler
function mat4FromTRS(px, py, pz, rx, ry, rz, sy, out) {
  // trig 101
  const cx = Math.cos(rx), sx = Math.sin(rx);
  const cy = Math.cos(ry), sy1 = Math.sin(ry);
  const cz = Math.cos(rz), sz = Math.sin(rz);

  // euler
  const m00 = cy * cz;
  const m01 = cz * sy1 * sx - sz * cx;
  const m02 = cz * sy1 * cx + sz * sx;

  const m10 = cy * sz;
  const m11 = sz * sy1 * sx + cz * cx;
  const m12 = sz * sy1 * cx - cz * sx;

  const m20 = -sy1;
  const m21 = cy * sx;
  const m22 = cy * cx;

  // linear algebruh
  out[0] = m00; out[1] = m01 * sy; out[2] = m02; out[3] = 0;
  out[4] = m10; out[5] = m11 * sy; out[6] = m12; out[7] = 0;
  out[8] = m20; out[9] = m21 * sy; out[10] = m22; out[11] = 0;

  // translation
  out[12] = px;
  out[13] = py;
  out[14] = pz;
  out[15] = 1;
}


  // game loop
  let last = performance.now();
  function loop(t) {
    const dt = Math.min(0.05, (t - last) / 1000);
    last = t;

    scrollVel *= 0.1;
    const time = t / 1000;

    let mIndex = 0;
    for (let i = 0; i < COUNT; i++) {
      const wind = Math.sin((time + i) * 0.5) * 0.18;

      pos[3 * i + 0] += (vel[3 * i + 0] + wind * 0.6) * dt;
      pos[3 * i + 1] -= (vel[3 * i + 1] * dt - scrollVel * 0.333);
      pos[3 * i + 2] += vel[3 * i + 2] * dt;

      rot[3 * i + 0] += rotSpeed[3 * i + 0] * dt;
      rot[3 * i + 1] += rotSpeed[3 * i + 1] * dt;
      rot[3 * i + 2] += rotSpeed[3 * i + 2] * dt;

      if (pos[3 * i + 1] < BOTTOM_KILL) seed(i);

      mat4FromTRS(
        pos[3 * i], pos[3 * i + 1], pos[3 * i + 2],
        rot[3 * i], rot[3 * i + 1], rot[3 * i + 2],
        scaleY[i],
        instanceMatrices.subarray(mIndex, mIndex + 16)
      );
      mIndex += 16;
    }

    gl.bindBuffer(gl.ARRAY_BUFFER, vboInstance);
    gl.bufferSubData(gl.ARRAY_BUFFER, 0, instanceMatrices);

    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    gl.enable(gl.DEPTH_TEST);

    gl.drawArraysInstanced(gl.TRIANGLES, 0, VERT_COUNT, COUNT);

    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
}
